import React, { useState } from 'react';
import { FormContext, useForm } from 'react-hook-form';
import { StatusManager } from 'common/components/StatusManager';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import { DiscardBulkDialog } from 'UI/components/organisms/BulkEmail/DiscardBulkDialog';
import { useBulkDrawerCommonStyles } from 'UI/components/organisms/BulkEmailDrawer/styles';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import { UIStatus } from 'UI/constants/status';
import { getOrdinalSuffix } from 'UI/utils';

import { BulkAttemptForm } from '../BulkEmailDrawerAttempts/BulkAttemptForm';
import { BulkEmailSectionsCollapser } from '../BulkEmailSectionsCollapser';

const { sequences: sequencesCopies } = strings.bulkEmails.forms;

export const BulkEmailEditAttemptDrawer = ({ attemptId = null, attemptNumber = null, onClose }) => {
  const commonClasses = useBulkDrawerCommonStyles();
  const form = useForm();
  const { triggerValidation } = form;
  const [uiState, setUiState] = useState({
    isFormLoading: false,
    isDiscardDialogOpen: false
  });

  const togglers = {
    discardDialog:
      ({ open }) =>
      () =>
        setUiState(prev => ({ ...prev, isDiscardDialogOpen: open }))
  };

  const drawerButtonDefinitions = [
    {
      props: {
        text: sequencesCopies.editAttempt.buttonsDefinitions.cancel,
        variant: 'outlined',
        onClick: togglers.discardDialog({ open: true })
      },
      visible: true
    },
    {
      props: {
        text: sequencesCopies.editAttempt.buttonsDefinitions.preview,
        variant: 'contained',
        onClick: () => triggerValidation()
      },
      visible: true
    }
  ];

  return (
    <>
      <FPDrawer
        CardHeaderProps={{ title: sequencesCopies.editAttempt.title }}
        footer={
          <FPButtonBuilder
            GridContainerProps={{ spacing: 2 }}
            buttonDefinitions={drawerButtonDefinitions}
          />
        }
        FPDrawerProps={{
          open: true,
          classes: { paper: commonClasses.drawerRoot }
        }}
        contentContainerClassName={commonClasses.contentContainer}
        hasPaddingContent={false}
        onClose={togglers.discardDialog({ open: true })}
      >
        <StatusManager status={uiState.isFormLoading ? UIStatus.Loading : UIStatus.Success}>
          <FormContext {...form}>
            <BulkEmailSectionsCollapser
              title={strings.formatString(sequencesCopies.sections.title, {
                attempt: getOrdinalSuffix(attemptNumber)
              })}
            >
              <BulkAttemptForm
                attemptId={attemptId}
                onFetchingSmartTags={({ loading }) =>
                  setUiState(prev => ({ ...prev, isFormLoading: loading }))
                }
              />
            </BulkEmailSectionsCollapser>
          </FormContext>
        </StatusManager>
      </FPDrawer>
      <When condition={uiState.isDiscardDialogOpen}>
        <DiscardBulkDialog
          isBulkBeingEdited
          onDiscard={onClose}
          onKeepEditing={togglers.discardDialog({ open: false })}
          onSaveChanges={() => {}}
          selectedMenuItem="sequenceAttempt"
        />
      </When>
    </>
  );
};
